import {useEffect, useState} from "react";
import {Autocomplete, TextField, CircularProgress, useTheme} from "@mui/material";
import useVehicle from "../hooks/useVehicle";

const VehicleTypeDropdownComponent = (props) => {
    const {onChange, value, fullWidth, size, customStyles, disabled} = props;

    const theme = useTheme();

    const {isFetchingVehicleType, vehicleTypes, getVehicleTypes} = useVehicle();
    const [vehicleTypesData, setVehicleTypesData] = useState([]);

    const [stateValue, setStateValue] = useState(null);
    const [inputValue, setInputValue] = useState("");
    

    useEffect(() => {
        getVehicleTypes();
    }, [])

    useEffect(() => {
        setStateValue(value || null);
        setInputValue(value || "");

        if (vehicleTypes?.length > 0) {
            const filteredVehicleTypes = vehicleTypes?.filter((type) => type !== value);

            setVehicleTypesData(filteredVehicleTypes);
        }
    }, [vehicleTypes, value])
    

    const handleChange = (newValue) => {
        setStateValue(newValue);
        setInputValue(newValue || "");
        onChange(newValue);
    }


    return (
        <>
            <Autocomplete
                disabled={disabled ? disabled : false}
                disablePortal
                options={vehicleTypesData}
                getOptionLabel={(option) => option || ""}
                isOptionEqualToValue={(option, value) => option === value}
                fullWidth={fullWidth}
                size={size}
                value={stateValue}
                loading={isFetchingVehicleType}
                onChange={(event, newValue) => handleChange(newValue)}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
                noOptionsText="Vehicle Type not found."
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Select vehicle type"
                        slotProps={{
                            input: {
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {(isFetchingVehicleType) ? <CircularProgress color="inherit" size={20} /> : null}
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                            },
                        }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: "4px", 
                                height: "42px",
                                paddingTop: '6px', 

                                '& input': {
                                    color: theme.typography.main,
                                    fontSize: 16,
                                    fontWeight: 500,

                                    '&::placeholder': {
                                        color: theme.typography.secondary,               
                                        opacity: 0.45,    
                                        fontSize: 15,    
                                        fontWeight: "400 !important",                     
                                    },
                                },

                                '& fieldset': {
                                    borderColor: "#e5edf6",
                                },

                                '&:hover fieldset': {
                                    borderColor: "#e5edf6",
                                },

                                '&.Mui-focused fieldset': {
                                    borderColor: "#253e5a9e",
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: theme.typography.secondary,               
                                opacity: 0.45,    
                                fontSize: 15,    
                                fontWeight: "400 !important",
                                marginTop: "-5px",
                            },
                        }}
                    />
                )}
                sx={{...customStyles}}
            />
        </>
    )
}

export default VehicleTypeDropdownComponent